import { render, staticRenderFns } from "./CalificacionCapturar.vue?vue&type=template&id=a6e97b0a"
import script from "./CalificacionCapturar.vue?vue&type=script&lang=js"
export * from "./CalificacionCapturar.vue?vue&type=script&lang=js"
import style0 from "~/../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports